import React from "react";
import styles from "./ReservationTimeoutModal.module.css";
import { ReactComponent as TimeoutIcon } from "../../assets/icons/timeout-icon.svg";
import { ReactComponent as AngelDownIcon } from "../../assets/icons/AngelDown.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/Close.svg";

interface ReservationTimeoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onReserveAgain: () => void;
}

const ReservationTimeoutModal: React.FC<ReservationTimeoutModalProps> = ({ isOpen, onClose, onReserveAgain }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        {/* دکمه بستن مودال */}
        <button className={styles.closeButton} onClick={onClose}>
          <CloseIcon className={styles.closeIcon} />
        </button>

        {/* عنوان بالا و راست */}
        <h2 className={styles.modalTitle}>پایان فرصت رزرو سرویس</h2>

        {/* آیکون اصلی */}
        <div className={styles.iconContainer}>
          <TimeoutIcon className={styles.iconImage} />
        </div>

        {/* توضیحات */}
        <p className={styles.modalText}>
          مدت زمان رزرو سرویس انتخاب شده (لایت مو - هانیه علیداده) رو به اتمام است و به زودی از لیست شما پاک می‌شود.
        </p>
        <p className={styles.modalText}>
          جهت رزرو سرویس لطفاً نسبت به پرداخت آن اقدام کنید.
        </p>

        {/* دکمه رزرو مجدد */}
        <button className={styles.reserveButton} onClick={onReserveAgain}>
          <AngelDownIcon className={styles.reserveIcon} />
          <span>رزرو وقت و پرداخت</span>
        </button>
      </div>
    </div>
  );
};

export default ReservationTimeoutModal;
